import { useEffect, useRef, useState } from 'react';
import styles from './history-bet.style';
import gameApi from 'apis/gameApi';
import { isMobile } from 'react-device-detect';
import HistoryBetDesktop from './HistoryBetDesktop';
import HistoryBetMobile from './HistoryBetMobile';
import { GameInstance } from 'models/gameModel';

interface Props {
    onClose: () => void;
    liveGameId: number | string;
    gameList: GameInstance[];
}
function HistoryBet(props: Props) {
    const { onClose, liveGameId, gameList } = props;
    const inputPageRef = useRef<HTMLInputElement>(null);
    const tableRef = useRef<HTMLDivElement>(null);
    const [historyMyBetData, setHistoryMyBetData] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState<number | null>(null);
    const [gameActive, setGameActive] = useState<GameInstance>(gameList[0]);
    useEffect(() => {
        const getHistoryBet = async () => {
            try {
                const { data } = await gameApi.getHistoryBet({ game_instance_id: gameActive.id, limit: 8, page: currentPage });
                if (data.code === 200) {
                    setHistoryMyBetData(data.data.items);
                    setLastPage(data.data.meta.last_page);
                    setTimeout(() => {
                        if (tableRef.current) {
                            tableRef.current.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                            });
                        }
                    }, 100);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getHistoryBet();
    }, [currentPage, gameActive]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const page = Number((e.target as any).value);
            if (page < 1) {
                return;
            }
            setCurrentPage(page);
        }
    };

    const handleChangePage = (type: 'PREV' | 'NEXT') => {
        if (type === 'PREV') {
            if (currentPage === 1) {
                return;
            }
            setCurrentPage((page) => page - 1);
        } else {
            setCurrentPage((page) => page + 1);
        }

        if (inputPageRef.current) {
            inputPageRef.current.value = type === 'PREV' ? String(currentPage - 1) : String(currentPage + 1);
        }
    };

    const changeGame = (gameId: string) => {
        const gameSelect = gameList.find((game) => game.id === Number(gameId));
        if (gameSelect) {
            setGameActive(gameSelect);
            if (inputPageRef.current) {
                inputPageRef.current.value = '1';
            }
            setCurrentPage(1);
        }
    };

    return (
        <div className={styles.wrap}>
            <h4 className="title">Lịch Sử Cược</h4>
            <button type="button" className={styles.btnClose} onClick={onClose}>
                <img src={require('assets/images/icons/close.png')} alt="" />
            </button>
            <div className={`${styles.wrapTable} ${isMobile ? 'mobile-view' : ''}`} ref={tableRef}>
                {!isMobile ? (
                    <HistoryBetDesktop gameType={gameActive.type.id} betData={historyMyBetData} />
                ) : (
                    <HistoryBetMobile gameType={gameActive.type.id} betData={historyMyBetData} />
                )}
            </div>

            <div className={`history-footer ${isMobile ? 'mobile' : ''}`}>
                <div className="game-option">
                    <label htmlFor="gameSelect">Bàn</label>
                    <select id="gameSelect" onChange={(e) => changeGame(e.target.value)}>
                        {gameList.map((game) => (
                            <option key={game.id} value={game.id}>
                                {game.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={`${styles.pagination} pagination`}>
                    <button type="button" onClick={() => handleChangePage('PREV')} disabled={currentPage === 1}>
                        <img src={require('assets/images/icons/btn-prev.png')} alt="" />
                    </button>
                    <input type="number" onKeyDown={handleKeyDown} ref={inputPageRef} defaultValue={1} />
                    <button type="button" onClick={() => handleChangePage('NEXT')} disabled={lastPage === currentPage}>
                        <img src={require('assets/images/icons/btn-next.png')} alt="" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default HistoryBet;
